import React, { Component } from "react";
import { AuthProvider } from "./auth";
import ProtectedRoute from "./component/ProtectedRoute";
import Login from "./component/Login";
import SearchPage from "./pages/SearchPage";
import { Route, Switch, Redirect, BrowserRouter as Router } from "react-router-dom";

import "./assets/css/materialdesignicons.min.css";

import "./assets/scss/themes.scss";
import './App.css';

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <AuthProvider>
          <Router>
            <Switch>
              <Route exact path="/login" component={Login} />
              <ProtectedRoute exact path="/search" component={SearchPage} />
              <Redirect to="/search" />
            </Switch>
          </Router>
        </AuthProvider>
      </React.Fragment>
    );
  }
}

export default App;
